/**
 * Header
 */
const componentHeader = () => {

  const header = document.querySelector('#masthead');
  if (!header) return;

  var headroom  = new Headroom(header, {
    offset: 64,
    tolerance: {
      up: 12,
      down: 0
    }
  });

  headroom.init();

};
componentHeader();

/**
 * Fix header padding
 */
const componentHeaderPadding = () => {

    const header = document.querySelector('#masthead');
    const mainHeader = document.querySelector('.js-main-header');

    const mobileMenu = document.querySelector('.js-mobile-menu-nav');
    const searchOverlay = document.querySelector('.js-search-overlay-content');
    const content = document.querySelector('#content');

    const headerHeight = header.offsetHeight;
    const mainHeaderHeight = mainHeader.offsetHeight;

    content.style.marginTop = headerHeight + 'px';
    mobileMenu.style.top = headerHeight + 'px';
    searchOverlay.style.top = headerHeight + 'px';
    // searchOverlay.style.top = mainHeaderHeight + 'px';

};
componentHeaderPadding();
document.addEventListener('DOMContentLoaded', componentHeaderPadding);
window.addEventListener('resize', componentHeaderPadding);
window.addEventListener('orientationchange', componentHeaderPadding);
window.addEventListener('load', componentHeaderPadding);

/**
 * Cinema picker (desktop)
 */
const componentCinemaPickerDesktop = () => {
  const cinemaPickerWrapper = document.querySelector('.js-cinema-picker-d-wrap');
  const cinemaPicker = document.querySelector('.js-cinema-picker-d');
  const cinemaPickerOptions = document.querySelector('.js-cinema-picker-d-options');
  tippy(cinemaPicker, {
    content: cinemaPickerOptions.innerHTML,
    allowHTML: true,
    interactive: true,
    arrow: false,
    trigger: 'click mouseenter',
    theme: 'light',
    maxWidth: 'none',
    placement: 'bottom-start',
    offset: [0, 0],
    // on open add class to cinemaPicker
    onShow(instance) {
      cinemaPickerWrapper.classList.add('is-active');
    },
    onHide(instance) {
      cinemaPickerWrapper.classList.remove('is-active');
    }
  });
};
componentCinemaPickerDesktop();

/**
 * Language switcher (desktop)
 */
const componentLanguageSwitcherDesktop = () => {
  const languageSwitcherWrapper = document.querySelector('.js-lang-switcher-d-wrap');
  const languageSwitcher = document.querySelector('.js-lang-switcher-d');
  const languageSwitcherOptions = document.querySelector('.js-lang-switcher-d-options');
  tippy(languageSwitcher, {
    content: languageSwitcherOptions.innerHTML,
    allowHTML: true,
    interactive: true,
    arrow: false,
    trigger: 'click mouseenter',
    theme: 'light',
    maxWidth: 'none',
    placement: 'bottom-start',
    offset: [0, 0],
    onShow(instance) {
      languageSwitcherWrapper.classList.add('is-active');
    },
    onHide(instance) {
      languageSwitcherWrapper.classList.remove('is-active');
    }
  });
};
componentLanguageSwitcherDesktop();
